"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var Base_1 = __importDefault(require("./Base"));
var Zoom = /** @class */ (function (_super) {
    __extends(Zoom, _super);
    function Zoom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Zoom.prototype.zoomIn = function () {
        var zoomRatio = this.canvas.getZoom();
        zoomRatio += 0.05;
        var center = this.canvas.getCenter();
        this.zoomToPoint(new fabric_1.fabric.Point(center.left, center.top), zoomRatio);
        this.state.setZoomRatio(zoomRatio);
    };
    Zoom.prototype.zoomOut = function () {
        var zoomRatio = this.canvas.getZoom();
        zoomRatio -= 0.05;
        var center = this.canvas.getCenter();
        this.zoomToPoint(new fabric_1.fabric.Point(center.left, center.top), zoomRatio);
        this.state.setZoomRatio(zoomRatio);
    };
    Zoom.prototype.zoomToOne = function () {
        var center = this.canvas.getCenter();
        this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        this.zoomToPoint(new fabric_1.fabric.Point(center.left, center.top), 1);
        this.state.setZoomRatio(1);
    };
    Zoom.prototype.zoomToFit = function () {
        var zoomFitRatio = this.editor.frame.fitRatio;
        var center = this.canvas.getCenter();
        this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        this.zoomToPoint(new fabric_1.fabric.Point(center.left, center.top), zoomFitRatio);
        this.state.setZoomRatio(zoomFitRatio);
    };
    Zoom.prototype.zoomToRatio = function (zoomRatio) {
        var center = this.canvas.getCenter();
        this.zoomToPoint(new fabric_1.fabric.Point(center.left, center.top), zoomRatio);
        this.state.setZoomRatio(zoomRatio);
    };
    Zoom.prototype.zoomToPoint = function (point, zoom) {
        var minZoom = 10;
        var maxZoom = 300;
        var zoomRatio = zoom;
        if (zoom <= minZoom / 100) {
            zoomRatio = minZoom / 100;
        }
        else if (zoom >= maxZoom / 100) {
            zoomRatio = maxZoom / 100;
        }
        this.canvas.zoomToPoint(point, zoomRatio);
        this.state.setZoomRatio(zoomRatio);
    };
    return Zoom;
}(Base_1.default));
exports.default = Zoom;
//# sourceMappingURL=Zoom.js.map